import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/fiscal/emitente' };
/////////////////////////////////////////////////////////////////////////////////

export function createEmitenteCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateEmitenteCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listEmitenteCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findEmitenteCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllEmitenteCadastro() {
  return httpService.get({ ...args, path: '/fiscal/emitente/all' });
}

export function deleteEmitenteCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

export function findCnpj(cnpj) {
  return httpService.get({ ...args, args: `/find/dataByCnpj/${cnpj}` });
}

export function findCep(cep) {
  return httpService.get({ ...args, args: `/find/addressByCep/${cep}` });
}